module.exports = __webpack_public_path__ + "static/img/9.f30e96a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/9.png
// module id = EZ45
// module chunks = 0